/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Risk List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RiskListView';

export const mapStateToPropsRiskList = mapStateToProps;
export const mapDispatchToPropsRiskList = mapDispatchToProps;

export default connect(
  mapStateToPropsRiskList,
  mapDispatchToPropsRiskList
)(View);
